import didomiService from '../utils/DidomiService'
export default defineNuxtPlugin(() => {
  didomiService.init()
  return {
    provide: {
      didomiService: {
        showPreferences: () => didomiService.showPreferences(),
        hasConsent: (consent: string) => didomiService.hasConsent(consent),
        onReady: (cb: (...args: unknown[]) => unknown) =>
          didomiService.onReady(cb),
      },
    },
  }
})
